  
export const styles = theme => ({
    containerToastr: {
        letterSpacing: '.3px',
        lineHeight: '1.6',
        fontSize: '0.875rem',
        fontFamily: 'Nunito,sans-serif',
    } 
});
   